<template>
    <v-card class="pa-2">
        <v-card-text class="text-xs-center headline">
            Tem certeza que deseja deletar a rede <b>{{rede.nome}}</b>?
        </v-card-text>
        <v-card-actions class="justify-space-between mt-2">
          <v-btn @click="$emit('fechar')">Cancelar</v-btn>
          <v-btn color="error" @click="deletarRede">Confirmar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['rede'],
  methods: {
    deletarRede () {
      this.$store.dispatch('deletarRede', this.rede.id_rede).then(() => {
        this.$store.dispatch('pegarRedes')
        this.$emit('success', 'Rede deletada com sucesso.')
        this.$emit('fechar')
      }).catch(() => {
        this.$emit('error', 'Não foi possível deletar rede.')
      })
    }
  }
}
</script>
